import { useCallback } from 'react';
import { TimeSignal, TimeSignalClassification } from 'graphql/types';
import { useBulkUpdateTimeSignals } from '../../hooks/useBulkUpdateTimeSignals';
import { TimesheetLabel } from '../../../timesheet-labels/labelSchema';

export type MultiEditActionArgs = {
  notes: TimeSignal[];
  classificationTarget: TimeSignalClassification;
  labelValues: TimesheetLabel[];
};
export type HandleMultiEditActionCallback = ({
  notes,
  labelValues,
  classificationTarget
}: MultiEditActionArgs) => Promise<void>;

type ReturnType = {
  handleMultiEditAction: HandleMultiEditActionCallback;
  isActionInProgress: boolean;
};

//Todo: Remove this when time-signal-federated-suggestions FF is rolled out (TIDP-1469)
export const useMultiEditActions = (): ReturnType => {
  const {
    onMultiEditTimeSignals,
    updateInProgress
  } = useBulkUpdateTimeSignals();

  const handleMultiEditAction = useCallback(
    async ({
      notes,
      labelValues,
      classificationTarget
    }: MultiEditActionArgs) => {
      await onMultiEditTimeSignals({
        notes: notes,
        labelValues: labelValues,
        classificationTarget: classificationTarget
      });
    },
    [onMultiEditTimeSignals]
  );
  return {
    handleMultiEditAction: handleMultiEditAction,
    isActionInProgress: updateInProgress
  };
};
